import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["collapsedIcon", "expandedIcon", "content"];
  static values = { hidden: { type: Boolean, default: false } };

  toggleContent() {
    if (this._isExpanding()) {
      this._expand();
    } else {
      this._collapse();
    }

    this.hiddenValue = !this.hiddenValue;
  }

  _expand() {
    this.collapsedIconTarget.classList.add("hidden");
    this.expandedIconTarget.classList.remove("hidden");

    const content = this.contentTarget;
    content.style.maxHeight = `${content.scrollHeight}px`;

    // Once the panel has opened, drop the height cap so tall content (many open
    // considerations) grows naturally instead of being clipped.
    content.addEventListener(
      "transitionend",
      () => {
        if (!this.hiddenValue) content.style.maxHeight = "";
      },
      { once: true },
    );
  }

  _collapse() {
    this.collapsedIconTarget.classList.remove("hidden");
    this.expandedIconTarget.classList.add("hidden");

    const content = this.contentTarget;
    // Pin the current height, force a reflow, then animate down to zero.
    content.style.maxHeight = `${content.scrollHeight}px`;
    void content.offsetHeight; // force a reflow so the transition to 0 animates
    content.style.maxHeight = "0px";
  }

  _isExpanding() {
    return this.hiddenValue;
  }
}
